import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Home from './pages/Home'

// Future pipeline routes (Phase 3):
// import Book from './pages/Book'
// import Dashboard from './pages/Dashboard'
// import Pay from './pages/Pay'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/book" element={<Book />} /> */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/pay" element={<Pay />} /> */}
      </Routes>
      <Analytics />
    </BrowserRouter>
  )
}
